<template>
    <div class="flip-card-wrapper">
        <div
            v-for="(item,index) in list"
            :key="index"
            :class="{'is-need-animation':item.isNeedAnimation}"
            class="flip-card-item"
        >
            <div class="flip-card-item-card flip-card-item-front">{{ item.front }}</div>
            <div class="flip-card-item-card flip-card-item-back">{{ item.back }}</div>
        </div>
    </div>
</template>

<script>
import { addClass } from '@/scripts/views/page/util';
import formatNumber from '../../../../utils/formatNumber';
import { get } from 'lodash';

/**
 * 卡片翻转效果
 */
export default {
    name: 'FlipCard',
    props: {
        /**
         * 总量
         */
        totalNumber: {
            type: [String, Number]
        },
        /**
         * 上个总量
         */
        prevTotalNumber: {
            type: [String, Number]
        },
    },
    data() {
        return {
            list: []

        };
    },
    mounted() {
        let res = [];
        const formatTotalNumberArray = (formatNumber(this.totalNumber) || '').split('');
        if (this.prevTotalNumber >= this.totalNumber) {
            this.list = formatTotalNumberArray.map(item=>({ front: item, back: item, isNeedAnimation: false }));
            return;
        }
        const prevTotalNumberArray = formatNumber(this.prevTotalNumber).split('').reverse();
        formatTotalNumberArray.reverse().forEach((num, index) => {
            const front = get(prevTotalNumberArray, index, '');
            res.push({ front, back: num, isNeedAnimation: front !== num });
        });
        this.list = res.reverse();
        setTimeout(() => {
            document.querySelectorAll('.flip-card-item.is-need-animation').forEach((el, index) => {
                addClass(el, 'flip-card-item-flipped');
                el.style.transitionDelay = `${index * 0.1}s`;
            });
        }, 50);
    }
};
</script>
<style lang="scss">
.flip-card-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    .flip-card-item {
        margin-right: 4px;
        perspective: 60px;
        width: 26px;
        height: 58px;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 0.3s;
    }

    .flip-card-item-card {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
        overflow: hidden;
        backface-visibility: hidden;
    }

    .flip-card-item-back {
        transform: rotatex(180deg);
    }

    .flip-card-item-flipped {
        transform: rotatex(180deg);
    }
}

</style>
